import gql from "graphql-tag";

import type {ApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

type Data = {
    user:
        | {
              id: string;
              discussionBanned: boolean;
          }
        | null
        | undefined;
};

type Variables = {
    kaid: string;
};

export const IS_HELLBANNED_QUERY: GqlOperation<Data, Variables> = gqlOp(gql`
    query isHellbanned($kaid: String!) {
        user(kaid: $kaid) {
            id
            discussionBanned
        }
    }
`);

// This (async) function returns `true` if the user with the given kaid
// has been "hell-banned", that is, barred from making new discussion
// posts.  Suitably powerful moderators have the power to hellban users
// to stop abuse (and to un-hellban them as well).
export function isHellbanned(
    gqlClient: ApolloGqlClient,
    kaid: string,
): Promise<boolean> {
    return gqlClient
        .query(IS_HELLBANNED_QUERY, {
            variables: {kaid: kaid},
            fetchPolicy: "network-only",
        })
        .then((result) => Boolean(result.data?.user?.discussionBanned));
}
